<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  stroke={color}
  stroke-width={strokeWidth}
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 48 48"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <path
    class="a"
    d="M18.41,4.5h6.27A1.49,1.49,0,0,1,26.17,6v5.34H16.92V6A1.49,1.49,0,0,1,18.41,4.5Zm-1.49,6.83h9.25V36.67H16.92Zm17.93-.92a1.75,1.75,0,0,1,2,1.45l.79,5L27,18.57l-.79-5a1.73,1.73,0,0,1,1.44-2l7.21-1.15Zm2.78,6.47,2.94,18.44L29.93,37,27,18.57l10.64-1.69Zm2.94,18.44.8,5a1.74,1.74,0,0,1-1.45,2l-7.21,1.15a1.75,1.75,0,0,1-2-1.45l-.79-5,10.64-1.69ZM8.29,7.84h7a1.68,1.68,0,0,1,1.68,1.68v5.15H6.61V9.52A1.68,1.68,0,0,1,8.29,7.84ZM6.61,14.67H16.92v22H6.61Zm0,22H16.92v5.15a1.68,1.68,0,0,1-1.68,1.68h-7a1.68,1.68,0,0,1-1.68-1.68Zm10.31,0h9.25V42a1.49,1.49,0,0,1-1.49,1.49H18.41A1.49,1.49,0,0,1,16.92,42Z"
  />
</svg>
